// src/api/client.js - Updated with JWT interceptors
import axios from 'axios';
import config from '../config';

const apiClient = axios.create({
  baseURL: config.apiUrl,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  timeout: 10000, // 10 seconds
});

// Request interceptor to add JWT token
apiClient.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    const token = localStorage.getItem('access_token');
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    console.log('API Request:', {
      url: `${config.baseURL}${config.url}`,
      method: config.method,
      headers: config.headers,
      params: config.params,
      data: config.data
    });
    
    return config;
  },
  (error) => {
    console.error('Request Error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor to handle authentication errors
apiClient.interceptors.response.use(
  (response) => {
    console.log('API Response:', {
      status: response.status,
      headers: response.headers,
      data: response.data
    });
    return response;
  },
  (error) => {
    if (error.response) {
      const { status } = error.response;
      
      // Handle authentication errors
      if (status === 401) {
        // Token is invalid or expired
        localStorage.removeItem('access_token');
        
        // Only redirect to login if we're not already on the login page
        // and if we're in a browser environment
        if (typeof window !== 'undefined' && 
            window.location.pathname !== '/login' && 
            window.location.pathname !== '/') {
          
          // Dispatch a custom event that the AuthContext can listen to
          window.dispatchEvent(new CustomEvent('auth:logout'));
          
          // Redirect to login page
          //window.location.href = '/login';
          window.history.replaceState(null, '', '/login');
          window.location.reload();
        
        
        }
      }
      
      // Handle authorization errors
      if (status === 403) {
        console.error('Access forbidden:', error.response.data);
        // You might want to show a "Access Denied" message
      }

      console.error('Response Error:', {
        status: error.response.status,
        headers: error.response.headers,
        data: error.response.data
      });
    } else if (error.request) {
      // The request was made but no response was received
      console.error('Request Error (No Response):', error.request);
    } else {
      // Something happened in setting up the request
      console.error('Error:', error.message);
    }
    
    return Promise.reject(error);
  }
);

export default apiClient;